/* Carrito limpio: precio tachado + precio + (Ahorras $X) bajo el nombre - Dear Noel */
(function () {
  if (window.__dnCartClean) return; window.__dnCartClean = true;
  var PROT = 'proteccion-de-envio';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var products = {}, timer = null;

  // Pesos chilenos: punto para los miles y sin decimales ($69.990)
  function money(c) { return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function getProduct(handle) {
    if (!products[handle]) {
      products[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
    }
    return products[handle];
  }

  async function render() {
    var rows = Array.prototype.filter.call(document.querySelectorAll('#CartDrawer .cart-item'), function (r) { return !r.querySelector('.dnc-pr'); });
    if (!rows.length) return;
    var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    var byVariant = {};
    cart.items.forEach(function (i) { if (!byVariant[i.variant_id]) byVariant[i.variant_id] = i; });
    for (var k = 0; k < rows.length; k++) {
      var row = rows[k];
      if (row.querySelector('.dnc-pr')) continue;
      var btn = row.querySelector('[data-variant-id]');
      var item = btn && byVariant[btn.getAttribute('data-variant-id')];
      if (!item) continue;
      if (item.handle === PROT) row.classList.add('dnc-prot');
      var compare = item.original_price;
      var p = await getProduct(item.handle);
      if (p && p.variants) {
        var v = p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
        if (v && v.compare_at_price > compare) compare = v.compare_at_price;
      }
      var price = item.final_price, save = compare - price;
      var el = document.createElement('div');
      el.className = 'dnc-pr';
      el.innerHTML = (save > 0 ? '<s>' + money(compare) + '</s>' : '') + '<b>' + money(price) + '</b>' +
        (save > 0 ? '<em>(Ahorras ' + money(save) + ')</em>' : '');
      var details = row.querySelector('.cart-item__details');
      var title = details && details.querySelector('.cart-item__title');
      if (!details || !title) continue;
      // Despues de la variante (si hay) o del nombre
      var dl = details.querySelector('dl');
      (dl || title).insertAdjacentElement('afterend', el);
      row.classList.add('dnc-priced');
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { render().catch(function () {}); }, 120); }

  function start() {
    schedule();
    new MutationObserver(function () {
      if (document.querySelector('#CartDrawer .cart-item:not(.dnc-priced)')) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
